(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/winplan-header.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/winplan-header.js');

'use strict';

svs.numbergames.game.views.WinPlanHeader = Marionette.View.extend({
  viewOptions: ['multipliedRowPrice'],
  className: 'winplan-header-content',
  modelEvents: {
    'change:level change:hasKungKeno change:board': 'render'
  },
  template: data => svs.numbergames.game.templates.winplan_header(data),
  templateContext() {
    return {
      multipliedRowPrice: this.multipliedRowPrice,
      rowCount: this.model.getNumberOfGeneratedRows()
    };
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onChangeRowPriceMulti(multipliedRowPrice) {
    this.multipliedRowPrice = multipliedRowPrice;
    this.render();
  }
});

 })(window);